const pt: Record<string, string> = {
  "Virtual Try-On": "Provador Virtual",
  "Find Your Size & See It On You": "Encontre seu tamanho e experimente",
  "See Your Fit": "Veja seu ajuste",
  "Check your size, then try it on virtually": "Confira seu tamanho e experimente virtualmente",
  "Get Your Size": "Seu tamanho",
  "Instant fit suggestion": "Sugestão de caimento instantânea",
  "Try It On": "Experimentar",
  "See how it looks on you": "Veja como fica em você",
  "Find My Size": "Encontrar meu tamanho",
  "Takes less than a minute": "Leva menos de um minuto",
  "Upload a full body photo": "Envie uma foto de corpo inteiro",
  "JPEG, PNG or WebP (max 10MB)": "JPEG, PNG ou WebP (máx. 10MB)",
  "Your photo": "Sua foto",
  "Let's find your best fit": "Vamos encontrar seu melhor caimento",
  "Centimeters": "Centímetros",
  "Inches": "Polegadas",
  "Load saved profile...": "Carregar perfil salvo...",
  "HEIGHT": "ALTURA",
  "WEIGHT": "PESO",
  "feet": "pés",
  "inches": "polegadas",
  "cm": "cm",
  "kg": "kg",
  "lbs": "libras",
  "in": "pol",
  "How to measure": "Como medir",
  "Hide guide": "Ocultar guia",
  "I know my measurements": "Sei minhas medidas",
  "Not sure? Use height & weight instead": "Não tem certeza? Use altura e peso",
  "Please fill in height and weight": "Por favor, preencha altura e peso",
  "Please fill in all required fields": "Por favor, preencha todos os campos obrigatórios",
  "Next": "Próximo",
  "Analyzing your size...": "Analisando seu tamanho...",
  "SUGGESTED SIZE": "TAMANHO SUGERIDO",
  "NOT SUGGESTED": "NÃO SUGERIDO",
  "Edit measurements": "Editar medidas",
  "Size guide": "Guia de tamanhos",
  "Your fit": "Seu caimento",
  "Your Suggested Size": "Seu tamanho sugerido",
  "Your measure": "Sua medida",
  "within range": "dentro da faixa",
  "too tight": "muito apertado",
  "tight": "apertado",
  "a bit tight": "um pouco apertado",
  "too loose": "muito folgado",
  "loose": "folgado",
  "a bit loose": "um pouco folgado",
  "See fit on your photo": "Ver caimento na sua foto",
  "Hide visual fit": "Ocultar caimento visual",
  "Analyzing...": "Analisando...",
  "Try it on": "Experimentar",
  "SIZE CHART": "TABELA DE TAMANHOS",
  "YOUR ESTIMATED MEASUREMENTS": "SUAS MEDIDAS ESTIMADAS",
  "Edit": "Editar",
  "Download": "Baixar",
  "Size chart": "Tabela de tamanhos",
  "Preparing your image...": "Preparando sua imagem...",
  "Analyzing body proportions...": "Analisando proporções corporais...",
  "Matching garment to your photo...": "Ajustando a peça à sua foto...",
  "Generating virtual try-on...": "Gerando provador virtual...",
  "Refining details...": "Refinando detalhes...",
  "Almost there...": "Quase lá...",
  "Complete!": "Concluído!",
  "This usually takes 15-25 seconds": "Isso geralmente leva 15-25 segundos",
  "Something went wrong": "Algo deu errado",
  "Try Again": "Tentar novamente",
  "We couldn't find a matching size for you": "Não encontramos um tamanho adequado para você",
  "Please try the manual measurement screen so we can calculate your fit from your measurements.": "Use a tela de medidas manuais para calcularmos o ajuste com base nas suas medidas.",
  "Try manual measurements": "Usar medidas manuais",
  "SDK not configured. Please provide an API key.": "SDK não configurado. Forneça uma chave API.",
  "Please upload a JPEG, PNG, or WebP image.": "Envie uma imagem JPEG, PNG ou WebP.",
  "Image must be under 10MB.": "A imagem deve ter menos de 10MB.",
  "Try-on generation failed": "Falha na geração da prova",
  "Failed to start try-on": "Falha ao iniciar a prova",
  "No product image found. Please set the product-image attribute.": "Imagem do produto não encontrada. Defina o atributo product-image.",
  "Powered by": "Desenvolvido por",
  "My Profiles": "Meus Perfis",
  "History": "Histórico",
  "No saved profiles yet.": "Nenhum perfil salvo.",
  "No history yet.": "Sem histórico.",
  "Product": "Produto",
  "Women's": "Feminino",
  "Men's": "Masculino",
  "Profiles": "Perfis",
  "Women's Profile": "Perfil Feminino",
  "Men's Profile": "Perfil Masculino",
  "Height": "Altura",
  "Weight": "Peso",
  "Chest": "Peito",
  "Bust": "Busto",
  "Waist": "Cintura",
  "Hips": "Quadril",
  "Shoulders": "Ombros",
  "Sleeve": "Manga",
  "Inseam": "Entrepernas",
  "Neck": "Pescoço",
  "Foot": "Pé",
  "Shoe EU": "Calçado EU",
  "Shoe US": "Calçado US",
  "Shoe UK": "Calçado UK",
  "Saved": "Salvo",
  "Delete Profile": "Excluir Perfil",
  "Shoe size (US)": "Tamanho do calçado (US)",
  "Shoe size (UK)": "Tamanho do calçado (UK)",
  "Shoe size (EU)": "Tamanho do calçado (EU)",
  "Generating...": "Gerando...",
  "Foot length": "Comprimento do pé",
  "Size": "Tamanho",
  "Try on size": "Experimentar tamanho",
  "e.g.": "ex.",
  "Drop your photo here or click to upload": "Arraste sua foto aqui ou clique para enviar",
  "This usually takes 15-20 seconds": "Isso geralmente leva 15-20 segundos",
  "Try-on result": "Resultado da prova",
  "Try Another": "Tentar outra",
  "Back": "Voltar",
  "You": "Você",
  "Garment": "Peça",
  "Your Height": "Sua Altura",
  "Your Weight": "Seu Peso",
  "Drag or scroll to set your height": "Arraste ou role para definir sua altura",
  "Drag or scroll to set your weight": "Arraste ou role para definir seu peso",
  "Enter height and weight first": "Insira primeiro altura e peso",

  // ── Field labels ──
  "Lens Width": "Largura da lente",
  "Bridge": "Ponte",
  "Arm Length": "Comprimento da haste",
  "Head Circumference": "Circunferência da cabeça",
  "Face Width": "Largura do rosto",
  "Temple": "Haste",
  "Around widest point": "Em torno do ponto mais largo",
  "Foot Length": "Comprimento do pé",
  "Shoulder": "Ombro",
  "Thigh": "Coxa",
  "Hip": "Quadril",

  // ── Units ──
  "Millimetre": "Milímetro",
  "Centimetre": "Centímetro",
  "Millimeters": "Milímetros",

  // ── Fit descriptors ──
  "Tight": "Apertado",
  "Loose": "Folgado",
  "Short": "Curto",
  "Long": "Longo",
  "✓ Fit": "✓ Caimento",
  "too short": "muito curto",
  "too long": "muito longo",
  "a bit short": "um pouco curto",
  "a bit long": "um pouco longo",

  // ── Length pills ──
  "Length": "Comprimento",
  "Length Adjustment": "Ajuste de comprimento",
  "Regular": "Regular",
  "Big": "Grande",
  "Big & Tall": "Grande & Alto",

  // ── Misc ──
  "preview": "pré-visualização",

  // ── BodyProfileView — photo upload area (left section) ──
  "Upload your photo": "Envie sua foto",
  "Upload a photo": "Enviar uma foto",
  "Click or drag a full-body photo": "Clique ou arraste uma foto de corpo inteiro",
  "Or upload a photo for AI sizing": "Ou envie uma foto para análise por IA",
  "Photo": "Foto",
  "How to take a good photo": "Como tirar uma boa foto",
  "How to take the best photo": "Como tirar a melhor foto",
  "Do": "Faça",
  "Don't": "Não faça",
  "Quick Tip": "Dica rápida",
  "The simpler your photo is, the more accurate your virtual try-on results will be.": "Quanto mais simples for sua foto, mais precisos serão os resultados da prova virtual.",
  "Choose a plain background (a light wall is ideal)": "Escolha um fundo liso (uma parede clara é ideal)",
  "Stand facing the camera with your full body in frame": "Fique de frente para a câmera com o corpo inteiro no enquadramento",
  "Stand straight and still, arms relaxed by your sides": "Fique reto e parado, com os braços relaxados ao lado do corpo",
  "Stand with your HEELS against a wall for best accuracy": "Fique com os CALCANHARES contra a parede para maior precisão",
  "Use natural or even lighting (e.g. near a window)": "Use luz natural ou uniforme (ex.: perto de uma janela)",
  "Wear fitted, simple clothing (e.g. neutral colors)": "Use roupas justas e simples (ex.: cores neutras)",
  "Don't wear loose, baggy, or layered clothing": "Não use roupas largas, folgadas ou sobrepostas",
  "Don't sit, pose, or bend your body": "Não sente, pose ou dobre o corpo",
  "Don't use strong backlighting": "Não use contraluz forte",
  "Don't take mirror photos or selfies": "Não tire fotos de espelho ou selfies",
  "Don't apply filters, effects, or edits": "Não aplique filtros, efeitos ou edições",

  // ── Age gate ──
  "Are you 18 or older?": "Você tem 18 anos ou mais?",
  "Yes": "Sim",
  "No": "Não",
  "Please confirm your age": "Por favor, confirme sua idade",
  "Please confirm that the person in the photo is 18 or older before uploading.": "Confirme que a pessoa na foto tem 18 anos ou mais antes de enviar.",
  "Under 18 — can't process this photo.": "Menor de 18 — não é possível processar esta foto.",
  "This photo appears to be of a minor. Please upload a photo of someone 18 or older.": "Esta foto parece ser de um menor. Envie uma foto de alguém com 18 anos ou mais.",
  "Different photo needed": "Outra foto é necessária",
  "Try another photo": "Tente outra foto",

  // ── Photo step controls ──
  "Continue": "Continuar",
  "Analyze My Size": "Analisar meu tamanho",
  "Analyzing photo…": "Analisando foto…",
  "Details": "Detalhes",
  "Image must be under 10MB": "A imagem deve ter menos de 10 MB",
  "Please upload an image file": "Envie um arquivo de imagem",
  "Please upload a photo": "Envie uma foto",
  "Prefer not to upload a photo?": "Prefere não enviar uma foto?",
  "Enter measurements manually": "Inserir medidas manualmente",
  "Legal Notice": "Aviso Legal",
  "Your image will be used to generate a virtual try-on preview showing how selected items may look and fit. Images are processed securely and are not stored after generation.": "Sua imagem será usada para gerar uma prévia da prova virtual mostrando como os itens selecionados podem aparecer e caber. As imagens são processadas com segurança e não são armazenadas após a geração.",

  // ── BodyProfileView — form (right section) ──
  "Body details": "Detalhes do corpo",
  "Your body details": "Seus detalhes corporais",
  "Body Measurements": "Medidas corporais",
  "AGE": "IDADE",
  "years": "anos",
  "Enter your height": "Insira sua altura",
  "Enter your weight": "Insira seu peso",
  "Enter your bra size": "Insira o tamanho do sutiã",
  "Please enter your height": "Insira sua altura",
  "Please enter your weight": "Insira seu peso",
  "Please enter a valid height": "Insira uma altura válida",
  "Please enter a valid weight": "Insira um peso válido",
  "Please enter a valid height (100-250 cm)": "Insira uma altura válida (100-250 cm)",
  "Please enter a valid weight (30-300 kg)": "Insira um peso válido (30-300 kg)",
  "Please select both band and cup size": "Selecione o tamanho da faixa e do bojo",
  "Select your bra size": "Selecione o tamanho do sutiã",
  "BAND": "FAIXA",
  "BAND SIZE": "TAMANHO DA FAIXA",
  "CUP": "BOJO",
  "CUP SIZE": "TAMANHO DO BOJO",
  "BRA REGION": "REGIÃO DO SUTIÃ",
  "Imperial": "Imperial",
  "Metric": "Métrico",
  "These calibrate the AI — all required.": "Estes calibram a IA — todos obrigatórios.",
  "Using": "Usando",
  "start fresh": "começar de novo",
  "Close": "Fechar",

  // ── Body shape questions ──
  "Which best describes your chest?": "Qual descreve melhor seu peito?",
  "WHICH BEST DESCRIBES YOUR CHEST?": "QUAL DESCREVE MELHOR SEU PEITO?",
  "Which best describes your hips?": "Qual descreve melhor seus quadris?",
  "WHICH BEST DESCRIBES YOUR HIPS?": "QUAL DESCREVE MELHOR SEUS QUADRIS?",
  "Which best describes your midsection?": "Qual descreve melhor sua cintura?",
  "WHICH BEST DESCRIBES YOUR MIDSECTION?": "QUAL DESCREVE MELHOR SUA CINTURA?",
  "Which best describes your seat?": "Qual descreve melhor seu traseiro?",
  "WHICH BEST DESCRIBES YOUR SEAT?": "QUAL DESCREVE MELHOR SEU TRASEIRO?",
  "Average": "Média",
  "Narrow": "Estreito",
  "Broad": "Largo",
  "Curvy": "Curvilíneo",
  "A slimmer, narrower chest build": "Um peito mais magro e estreito",
  "A moderate, proportionate chest": "Um peito moderado e proporcional",
  "A wider, more muscular chest": "Um peito mais largo e musculoso",
  "A flatter midsection with minimal protrusion": "Uma cintura mais plana com mínima protuberância",
  "A moderate, natural midsection shape": "Uma cintura moderada e natural",
  "A fuller, more rounded midsection": "Uma cintura mais cheia e arredondada",
  "A flatter backside with less projection": "Um traseiro mais plano com menos projeção",
  "A moderate, natural backside shape": "Um traseiro moderado e natural",
  "A fuller, more rounded backside": "Um traseiro mais cheio e arredondado",

  // ── Photo step — profile photo preload pill ──
  "Loaded from profile": "Carregada do perfil",
  "Clear": "Limpar",
};
export default pt;
